import { encode } from 'hi-base32'

const getDefaultState = () => {
  return {
    trusteesList: [],
    username: null,
    password: null,
    repeatPassword: null,
    acl: 0,
    mxn: false,
    changePasswordNextLogin: false,
    operator: false,
    block: false,
    permissions: {
      createRemoveUsers: false,
      listUsers: false,
      monitorRemoteLog: false,
      backupRestore: false,
      firmwareUpdate: false
    },
    tfa: {
      type: 1,
      truncOffset: 16,
      timeStep: 30,
      T0: 0,
      status: false,
      token: null,
      tokenIsValid: false,
      seed: null,
      options: ['disabled', 'hotp', 'totp', 'x509'],
      option: 'disabled',
      x509File: null
    },
    listUsers: [],
    requiredFieldsAreValid: false,
    loading: false,
    error: {
      status: false,
      message: null
    },
    userIcon: null,
    userIconColor: null
  }
}
export const state = {
  trusteesList: [],
  username: null,
  password: null,
  repeatPassword: null,
  acl: 0,
  mxn: false,
  changePasswordNextLogin: false,
  operator: false,
  block: false,
  permissions: {
    createRemoveUsers: false,
    listUsers: false,
    monitorRemoteLog: false,
    backupRestore: false,
    firmwareUpdate: false
  },
  tfa: {
    type: 1,
    truncOffset: 16,
    timeStep: 30,
    T0: 0,
    status: false,
    token: null,
    tokenIsValid: false,
    seed: null,
    options: ['disabled', 'hotp', 'totp', 'x509'],
    option: 'disabled',
    x509File: null
  },
  listUsers: [],
  requiredFieldsAreValid: false,
  loading: false,
  error: {
    status: false,
    message: null
  },
  userIcon: null,
  userIconColor: null
}

export const getters = {
  getAcl: (state, getters, rootState, rootGetters) => {
    return rootGetters['acl/getAcl']({
      isOperator: state.operator,
      isMxN: state.mxn,
      isTfa: state.tfa.status,
      isChangePass: state.changePasswordNextLogin,
      canCreateRemoveUsers: state.permissions.createRemoveUsers,
      canListUsers: state.permissions.listUsers,
      canMonitorRemoteLog: state.permissions.monitorRemoteLog,
      canBackupRestore: state.permissions.backupRestore,
      canFirmwareUpdate: state.permissions.firmwareUpdate
    })
  },
  hex2bin: state => {
    if (state.tfa.seed) {
      const s = state.tfa.seed
      const bin = []

      for (let i = 0; i < s.length; i += 2) {
        bin.push(parseInt(s.substr(i, 2), 16))
      }

      return bin
    }
  },
  getSeedBase32: (state, getters) => {
    if (state.tfa.seed) {
      const bin = getters.hex2bin
      return encode(bin)
    }
  },
  getQrCode: (state, getters) => {
    const secret = getters.getSeedBase32

    if (secret) {
      const issuer = 'Dinamo%20Networks'
      const user = state.username
      const algorithm = 'SHA1'
      const digits = 6
      const period = 30
      const hotp = `otpauth://hotp/${issuer}:${user}?secret=${secret}&issuer=${issuer}&counter=0`
      const totp = `otpauth://totp/${issuer}:${user}?secret=${secret}&issuer=${issuer}&algorithm=${algorithm}&digits=${digits}&period=${period}`
      return { hotp, totp }
    }
  }
  // getUserIcon: state => {
  //   if (state.block) return 'block'
  //   else return 'account_circle'
  // },
  // getUserIconColor: state => {
  //   const perm = this.$store.getters['acl/getPermissions']({ acl: state.acl })
  //   const sysPerm = this.userHaveSystemPermissions({ acl: state.acl })

  //   if (state.blocked) return 'grey'
  //   if (perm.isOperator) return 'red'
  //   else if (sysPerm) return 'orange'
  //   else return 'primary'
  // }
}

export const mutations = {
  SET_TRUSTEES_LIST (state, payload = []) {
    state.trusteesList = payload
  },
  SET_USERNAME (state, payload = null) {
    state.username = payload
  },
  SET_PASSWORD (state, payload = null) {
    state.password = payload
  },
  SET_REPEAT_PASSWORD (state, payload = null) {
    state.repeatPassword = payload
  },
  SET_ACL (state, payload = 0) {
    state.acl = payload
  },
  SET_TFA_STATUS (state, payload = false) {
    state.tfa.status = payload
  },
  SET_TFA_TOKEN (state, payload = null) {
    state.tfa.token = payload
  },
  SET_TOKEN_IS_VALID (state, payload = false) {
    state.tfa.tokenIsValid = payload
  },
  SET_TFA_SEED (state, payload = null) {
    state.tfa.seed = payload
  },
  SET_TFA_OPTION (state, payload) {
    state.tfa.option = payload
  },
  SET_TFA_T0 (state, payload = 0) {
    state.tfa.T0 = Number(payload)
  },
  SET_TFA_TIME_STEP (state, payload = 30) {
    state.tfa.timeStep = Number(payload)
  },
  SET_TFA_DEVICE (state, payload) {
    state.tfa.device = payload
  },
  SET_TFA_X509_FILE (state, payload) {
    state.tfa.x509File = payload
  },
  SET_MXN (state, payload = false) {
    state.mxn = payload
  },
  SET_BLOCK (state, payload = false) {
    state.block = payload
  },
  SET_CHANGE_PASSWORD_NEXT_LOGIN (state, payload = false) {
    state.changePasswordNextLogin = payload
  },
  SET_IS_OPERATOR (state, payload = false) {
    state.operator = payload
  },
  SET_PERMISSION_CREATE_REMOVE_USERS (state, payload = false) {
    state.permissions.createRemoveUsers = payload
  },
  SET_PERMISSION_LIST_USERS (state, payload = false) {
    state.permissions.listUsers = payload
  },
  SET_PERMISSION_MONITOR_REMOTE_LOG (state, payload = false) {
    state.permissions.monitorRemoteLog = payload
  },
  SET_PERMISSION_BACKUP_RESTORE (state, payload = false) {
    state.permissions.backupRestore = payload
  },
  SET_PERMISSION_FIRMWARE_UPDATE (state, payload = false) {
    state.permissions.firmwareUpdate = payload
  },
  SET_LIST_USERS (state, payload = []) {
    state.listUsers = payload
  },
  SET_REQUIRED_FIELDS_ARE_VALID (state, payload = false) {
    state.requiredFieldsAreValid = payload
  },
  SET_USER_ICON (state, payload = null) {
    state.userIcon = payload
  },
  SET_USER_ICON_COLOR (state, payload = null) {
    state.userIconColor = payload
  },
  CLEAR (state) {
    state.username = null
    state.password = null
    state.repeatPassword = null
  },
  SET_LOADING (state, payload = false) {
    state.loading = payload
  },
  SET_ERROR (state, payload) {
    state.error.status = true
    state.error.message = payload
  },
  CLEAR_ERROR (state) {
    state.error.status = false
    state.error.message = null
  },
  RESET_PROP_STATE (state, prop) {
    state[prop] = getDefaultState()[prop]
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export const actions = {
  init ({ commit }) {
    commit('resetState')
  },
  doResetState ({ commit }) {
    commit('resetState')
  },
  async createUser ({ state, commit, dispatch, rootState, getters }) {
    const hsm = rootState.hsm.instance
    const body = {
      usr: state.username,
      pwd: state.password,
      acl: getters.getAcl
    }

    try {
      await hsm.createUser({ body })

      if (state.tfa.status) {
        await dispatch('activateTFA')
      }
      if (state.block) {
        await dispatch('blockUser')
      }
      commit('resetState')
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async updateUser ({
    state,
    commit,
    dispatch,
    rootState,
    getters,
    rootGetters
  }) {
    const hsm = rootState.hsm.instance
    const userPartitionACL = await dispatch('getUserPartitionACL', { username: state.username })
    const body = {
      usr: state.username,
      acl: getters.getAcl + userPartitionACL
    }
    try {
      await hsm.updateAcl({ body })

      if (state.tfa.status) {
        await dispatch('activateTFA')
      }

      if (rootState.auth.username !== state.username) {
        if (state.block) {
          await dispatch('blockUser')
        } else {
          await dispatch('unblockUser')
        }
      }
      commit('resetState')
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async getListUsers ({ commit, dispatch, rootState }) {
    try {
      const users = await rootState.hsm.instance.getUsers()
      commit('SET_LIST_USERS', users)
      return users
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async getUserObjCount ({ dispatch, rootState }, { user }) {
    try {
      const body = { usr: user }
      const res = await rootState.hsm.instance.getUsrObjectCount({ body })
      return res
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async getListUserTrusters ({ dispatch, rootState }, { user }) {
    try {
      const body = { usr: user, op: 1 }
      const res = await rootState.hsm.instance.listUserTrust({ body })
      return res.trust
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async getListUserTrustees ({ commit, dispatch, rootState }, { user }) {
    try {
      const body = { usr: user, op: 2 }
      const res = await rootState.hsm.instance.listUserTrust({ body })
      commit('SET_TRUSTEES_LIST', res.trust)
      return res.trust
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async getUserPartitionACL ({ dispatch, rootState }, { username }) {
    try {
      const body = { usr: rootState.auth.username, op: 2 }
      const res = await rootState.hsm.instance.listUserTrust({ body })
      const trustList = res.trust
      const isTrustee = (element) => element.usr === username
      const index = trustList.findIndex(isTrustee)
      const value = trustList[index] ? trustList[index].acl : 0
      return value
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async getUserTrust ({ dispatch, rootState }, { user }) {
    try {
      const res = await Promise.all([
        rootState.hsm.instance.listUserTrust({ body: { usr: user, op: 1 } }),
        rootState.hsm.instance.listUserTrust({ body: { usr: user, op: 2 } })
      ])

      const obj = {
        trusters: res[0].trust,
        trustees: res[1].trust
      }
      return obj
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async deleteUser ({ commit, dispatch, rootState }, { user }) {
    try {
      const res = await rootState.hsm.instance.deleteUser({
        body: { usr: user }
      })
      commit('resetState')
      return res
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async blockUser ({ state, rootState, commit, dispatch }) {
    const hsm = rootState.hsm.instance
    const body = {
      usr: state.username,
      op: 1
    }

    try {
      const res = await hsm.blockUser({ body })
      commit('CLEAR_ERROR')
      return res
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async unblockUser ({ state, rootState, commit, dispatch }) {
    const hsm = rootState.hsm.instance
    const body = {
      usr: state.username,
      op: 0
    }

    try {
      const res = await hsm.blockUser({ body })
      commit('CLEAR_ERROR')
      return res
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async userIsBlocked ({ rootState, commit, dispatch }, { user }) {
    const hsm = rootState.hsm.instance
    const body = {
      usr: user,
      op: 2
    }

    try {
      const res = await hsm.blockUser({ body })
      commit('CLEAR_ERROR')
      return res.lock_ctr
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async activateTFA ({ state, rootState, commit, dispatch }) {
    const hsm = rootState.hsm.instance
    if (state.tfa.option === 'x509') {
      try {
        const body = {
          usr: state.username,
          file: state.tfa.x509File
        }
        const res = await hsm.newX509AuthSa(body)
        commit('CLEAR_ERROR')
        return res
      } catch (err) {
        commit('SET_LOADING', false)
        dispatch('error/setError', { error: err }, { root: true })
        throw err
      }
    } else {
      const body = {
        usr: state.username,
        key: state.tfa.seed,
        type: state.tfa.type,
        trunc_offset: state.tfa.truncOffset,
        time_step: -1,
        T0: -1
      }
      if (state.tfa.option === 'totp') {
        body.time_step = state.tfa.timeStep
        body.T0 = state.tfa.T0
      }

      try {
        const res = await hsm.newOathAuthSa({ body })
        commit('CLEAR_ERROR')
        return res
      } catch (err) {
        commit('SET_LOADING', false)
        dispatch('error/setError', { error: err }, { root: true })
        throw err
      }
    }
  },
  async disableTFA ({ rootState, commit, dispatch }, { user }) {
    const hsm = rootState.hsm.instance
    const body = {
      usr: user,
      sa: 17
    }

    try {
      const res = await hsm.delAuthSa({ body })
      return res
    } catch (err) {
      commit('SET_LOADING', false)
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async generateSeed ({ commit, rootState, dispatch }) {
    const hsm = rootState.hsm.instance

    try {
      const res = await hsm.genRand({ body: { len: 20 } })
      const seed = res.rnd
      commit('SET_TFA_SEED', seed)
    } catch (err) {
      commit('SET_LOADING', false)
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async getAclByUser ({ rootState, dispatch }, { user }) {
    try {
      const hsm = rootState.hsm.instance
      const body = {
        usr: user
      }

      const res = await hsm.getAcl({ body })
      return res.acl
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  resolveAcl (context, { current, acl }) {
    const res = (current |= acl)
    return res
  },
  async setSelectedUserNameAndACL ({ commit, dispatch }, { user, acl }) {
    try {
      commit('SET_TRUSTEE_NAME', user)
      commit('SET_TRUSTEE_ACL', acl)
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
    }
  },
  // Used at PermissionsNewModal (Trust Relationship)
  async setPartitionACL ({ rootState, dispatch }, { username, acl }) {
    try {
      const systemACL = await dispatch('getAclByUser', { user: username })
      const body = {
        usr: username,
        acl: systemACL - 15 + acl
      }
      rootState.hsm.instance.updateAcl({ body })
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async deletePartitionPermissions ({ rootState, dispatch }, { user }) {
    try {
      const hsm = rootState.hsm.instance
      const systemACL = await dispatch('getAclByUser', { user })
      const body = {
        usr: user,
        acl: systemACL - 15
      }
      hsm.updateAcl({ body })
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
    }
  }
}
